import React from 'react'
import PropTypes from 'prop-types'
import BonusHistory from './BonusHistory'
import HistoryLinkButton from './HistoryLinkButton'
import useBonusHistory from '../hooks/useBonusHistory'

const BonusHistorySection = ({ hasBonus, bonusesPath, t }) => {
  const {
    bonuses,
    hasError,
    isLoading,
    isShowingBonusHistory,
    toggleBonusHistory,
  } = useBonusHistory(bonusesPath, t)

  if (!hasBonus) {
    return null
  }

  return (
    <div className="activeCollection_buttonWrapper d-block">
      <div className="activeCollection_bonuses">
        <HistoryLinkButton onClick={toggleBonusHistory}>
          {t['tcnext.see_bonus_history']}
        </HistoryLinkButton>
      </div>
      {isShowingBonusHistory && (
        <BonusHistory
          bonuses={bonuses}
          hasError={hasError}
          isLoading={isLoading}
          t={t}
        />
      )}
    </div>
  )
}

BonusHistorySection.propTypes = {
  bonusesPath: PropTypes.string.isRequired,
  hasBonus: PropTypes.bool.isRequired,
  t: PropTypes.object.isRequired,
}

export default BonusHistorySection
